/**
 * سطحُ الشاشة يحدّد مظهرها (قرار 18 سبتمبر 2026):
 *   • `app`    — داخل المنصة بعد الدخول: **نهاريٌّ (أبيض) افتراضاً**، وللمستخدم مبدّل.
 *   • `kid`    — بوابة الطفل: ليليةٌ دائماً، و`kid.css` لا تُمسّ.
 *   • `public` — الموقع العام وصفحات الدخول والتسجيل: ليليةٌ دائماً (هوية رفرفة).
 *
 * تُستعمل هذه القاعدة في موضعين لا بدّ منهما: هنا (React، بعد الإقلاع) وفي
 * `public/boot.js` (قبل أول طلاء، فلا يومض المظهر). **أي تعديلٍ هنا يُنقل هناك.**
 */
export type Surface = 'app' | 'kid' | 'public';

/** مسارات ما بعد الدخول — وما عداها عامّ */
const APP_PREFIXES = ['/app', '/platform', '/oversight', '/me'];

export function surfaceForPath(pathname: string): Surface {
  if (pathname === '/me/student' || pathname.startsWith('/me/student/')) return 'kid';
  return APP_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`)) ? 'app' : 'public';
}
